import axios from 'axios';
import apiLogger from '../apiLogger';

export const OMDB_BASE_URL = 'http://www.omdbapi.com/';
const OMDB_API_KEY = "9cd65e2f";

export const OMDB_axios_adapter = axios.create({
    baseURL: OMDB_BASE_URL,
    timeout: 60 * 1000,
    headers: {
        'Content-Type': 'application/json',
    },
});

OMDB_axios_adapter.interceptors.request.use(
    (config) => {
        // Ensure config.params exists
        config.params = config.params || {};

        // Add global query params
        config.params.apikey = `${OMDB_API_KEY}`;
        config.params.plot = "full";    // =>full/short
        config.params.r = "json";       // =>json/xml
        config.params.v = "1";          // =>1

        return config;
    },
    (error) => {
        return apiLogger.error(error);
    }
);

OMDB_axios_adapter.interceptors.response.use(
    (response) => {
        return apiLogger.response(response);
    },
    (error) => {
        return apiLogger.error(error);
    }
);
